import { defineAsyncComponent } from 'vue';
export * from './type';
export default {
    install: (app, options = {}) => {
        app.component('split-input', defineAsyncComponent(() => import('./components/SplitInput.vue')));
    },
};
